// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2dFkH","title":"Info_title__23ojc","selects":"Info_selects__PXI9V","requiredAsterisk":"Info_requiredAsterisk__2TQ3I"};